import BaseApi from '@/api/base';
import { getImpersonationParams } from '@/util';

const getMyDocuments = (homeId: string, divisionId: string, phase: string, params = {}) => BaseApi.get(`buyer/documents/${divisionId}/${homeId}/${phase}`, { params: getImpersonationParams(params) });

export { getMyDocuments };
